// Rotas que partem da Toro.User no lugar da Webapi
export const TORO_USER_API_URLS = [
    'v2/tags',
    'v1.1/users',
];
